import { REGIONS, DEFAULT_REGION } from './regions';

export function getLocaleFromPath(pathname) {
  if (!pathname || typeof pathname !== 'string') {
    return DEFAULT_REGION.code;
  }

  const segments = pathname.split('/').filter(Boolean);
  if (segments.length === 0) {
    return DEFAULT_REGION.code;
  }

  const firstSegment = '/' + segments[0].toLowerCase();
  const region = REGIONS.find((r) => r.prefix === firstSegment);
  return region ? region.code : DEFAULT_REGION.code;
}
